<template>
  <div class="RoleManagement">
    <AppHeader>角色管理</AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="部门">
            <el-select
                style="width: 150px"
                v-model="filter.assistDepartId"
                v-scroll="loadMore"
                placeholder="请选择"
                @change="onSubmit"
            >
              <el-option
                  v-for="item in searchList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
                v-model="filter.keyword"
                placeholder="角色名"
                @keyup.enter.native="onSubmit"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="toolsBox">
        <el-button type="primary" plain @click="handleAddRole" v-show="permissionCode.has('assist:role:manager')"
        >新增角色
        </el-button>
      </div>
      <RoleList :maxHeight="maxHeight"></RoleList>
    </AppBox>
  </div>
</template>

<script>
import RoleList from "@/pages/RoleManagement/RoleList.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "RoleManagement",
  components: {AppBox, AppHeader, RoleList},
  data() {
    return {
      maxHeight: null,
      searchList: [
        {
          id: null,
          name: "全部",
        },
        {
          id: 0,
          name: "其他",
        },
      ],
    };
  },
  computed: {
    ...mapState("fuzhu", ["buMenList", "roleList"]),
    ...mapState("teachingCenter", ["isBack"]),
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.fuzhu.roleListFilter;
      },
      set(value) {
        this.$store.commit("fuzhu/setData", {
          key: "roleListFilter",
          value,
        });
      },
    },
  },
  async mounted() {
    this.$nextTick(async () => {
      if (this.isBack) {
        await this.getRoleList({
          page: this.roleList.page,
          size: this.roleList.size,
        });
      }
      this.setData({key: "isBack", value: false});
    });
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    await this.getBuMenList({
      page: 1,
      size: 10,
    });
    this.searchList = this.searchList.concat(this.buMenList.data);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  methods: {
    ...mapActions("fuzhu", ["getBuMenList", "getRoleList"]),
    ...mapMutations("fuzhu", ["clearFilter"]),
    ...mapMutations("teachingCenter", ["setData"]),
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.56;
        } else {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.3;
        }
      });
    },
    handleAddRole() {
      this.$router.push(
          {
            name: "AddRole",
            params: {
              type: "add",
              assistDepartId: 0,
            },
          },
          () => {
          }
      );
    },
    async loadMore() {
      const currentPage = this.buMenList.page;
      const currentSize = this.buMenList.size;
      const currentTotal = this.buMenList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getBuMenList({
          page: this.buMenList.page + 1,
        });
        this.searchList = this.searchList.concat(this.buMenList.data);
      }
    },
    async onSubmit() {
      const filters = {
        ...this.filter,
      };
      filters.dateRange = undefined;
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getRoleList({
            ...filters,
            page: 1,
          });
        }
      });
    },
    // 重置
    async onReset() {
      await this.clearFilter();
      await this.getRoleList({
        page: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.RoleManagement {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }

    .toolsBox {
      text-align: right;
      margin-bottom: 20px;
    }
  }
}
</style>
